export enum BookingStatus {
  All = -1,

  /** Khởi tạo */
  Init = 9,

  /** Chờ gọi hãng để book vé */
  Pending = 0,

  /** Đặt giữ chỗ */
  Keep = 1,

  /** Đặt chỗ lỗi */
  Fail = 2,

  /** Đã thanh toán */
  Paid = 3,

  /** Chờ xuất vé */
  WaitTicket = 4,

  /** Xuất vé */
  ReleaseTicket = 5,

  /** Hủy đặt chỗ */
  Cancel = 6,

  /** Thanh toán lỗi */
  PaymentFail = 7,

  /** Đặt lại vé */
  Rebook = 8,
}
